'use strict';

const {ProcessInstance, ProcessDisplayDialogData} = require('./../../dialogs/bpmn-display/bpmn-display.dialog');
const DIALOG_REGISTRY = require('../../dialogs/dialog.registry');

module.exports = (app) => app.directive('processBpmn', /* @ngInject */ function () {
    return {
        restrict: 'E',
        scope: {
            /**
             * @type {string}
             */
            orderNumber: '@',
        },
        templateUrl: `./${BUILD_PATH}/process-bpmn.directive.html`,
        controller: /* @ngInject */ function ($scope, dialogService, processDataService, translationService) {

            $scope.processInstances = [];

            $scope.openDialog = openDialog;

            init();

            function init() {
                processDataService.getProcessInstancesByOrderNumber($scope.orderNumber).then((processInstances) => {
                    $scope.processInstances = processInstances.map(instance => new ProcessInstance(instance));
                    $scope.$apply();
                });
            }

            function openDialog() {
                if($scope.orderNumber && $scope.processInstances?.length) {
                    const data = new ProcessDisplayDialogData($scope.processInstances, $scope.orderNumber);
                    const title = translationService.translate(_('Prozess Status'))
                    const config = {
                        title,
                        style: {
                            height: '80vh',
                            'max-height': '80vh',
                            width: '90vw',
                            'max-width': '90vw'
                        }
                    };
                    dialogService.open(DIALOG_REGISTRY.BPMN_DISPLAY.templatePath, DIALOG_REGISTRY.BPMN_DISPLAY.id, data, config)
                }
            }
        }
    };
})
